import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './HpRespLocationsModuleItemList.scss';
import { trackShopByLocationClick } from '../helpers/shopByTracking';
import { slugify } from '../../utils/slugify';

function HpRespLocationsModuleItemList({ location, ipLink, additionalTopSpacing }) {
    const locationItems = location.items.filter(({ link }) => link !== ipLink);
    const containerClasses = classnames('colXs12 colLg3', {
        [styles.additionalTopSpacing]: additionalTopSpacing,
    });

    return (
        <div className={containerClasses}>
            <div className={styles.image} style={{ backgroundImage: `url(${location.imageUrl})` }}>
                <ul className={styles.locationsList}>
                    {locationItems.map((item, index) => (
                        <li
                            key={item.cmsId}
                            data-tn={`dealer-location-${slugify(item.title)}`}
                            className={styles.locationItem}
                        >
                            <a
                                href={item.link}
                                className={styles.locationLink}
                                onClick={() => trackShopByLocationClick(item, index)}
                            >
                                {item.title}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

HpRespLocationsModuleItemList.propTypes = {
    additionalTopSpacing: PropTypes.bool,
    location: PropTypes.object,
    ipLink: PropTypes.string,
};

export { HpRespLocationsModuleItemList };
